var check = "https://shopfront-cdn.tekoapis.com/static/d2123313b305a219.svg";

export { check as default };
